import Axios from "axios";

import {
    SET_INV_COUNTRY_LIST,
    UNSET_INV_COUNTRY_LIST,
} from "@/store/mutation-types";

import { getInvCountryList } from "@/store/api";

// initial state
const state = {
    getInvCountryList: [],
};


const getters = {
    getInvCountryList(state) {
        return state.getInvCountryList;
    }
};

const mutations = {
    [SET_INV_COUNTRY_LIST](state, data) {
        state.getInvCountryList = data;
    },
    [UNSET_INV_COUNTRY_LIST](state) {
        state.getInvCountryList = [];
    }
};


const actions = {
    getInvCountryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getInvCountryList, data)
                .then(function (response) {
                    commit('SET_INV_COUNTRY_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_INV_COUNTRY_LIST');
                    reject(error);
                })
                .then((always) => {
                });
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}